import { Constant } from "../../../../../../../constant"

const { CHECK_SELECTED_LANG } = Constant
export const format = CHECK_SELECTED_LANG ? "HH時mm分" : "HH:mm"
